import { ErrorHandler, Injectable, Inject, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  constructor(@Inject(Injector) private injector: Injector) {}

  // Need to get ToastrService from injector rather than constructor injection to avoid cyclic dependency error
  private get _toastrService(): ToastrService {
    return this.injector.get(ToastrService);
  }

  handleError(error: any): void {
    if (error instanceof HttpErrorResponse) {
      // Backend returns unsuccessful response codes such as 404, 500 etc.
      console.error('Backend returned:', error.message);
      if (error.status === 400) {
        error.error.forEach((err) => {
          this._toastrService.warning(err.message, 'Mensagem de erro');
          console.error('Backend body error:', err.message);
        });
      } else if (error.status === 401 || error.status === 403) {
        this._toastrService.error(
          'Você não está autorizado a acessar este recurso.',
          'Erro ' + error.status
        );
      } else {
        this._toastrService.error(error.message, 'Erro ' + error.status);
      }
    } else {
      // A client-side or network error occurred.
      console.error('An error occurred:', error.message);
    }
  }
}
